import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../identity/auth.service';
import { UserService } from '../../identity/user.service';

@Injectable({
  providedIn: 'root'
})
export class UserLoadedGuard  {
  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService) {
  }

  public async canActivate(routeSnap: ActivatedRouteSnapshot) {
    if (this.userService.isInitialized == false && this.authService.isAuthenticated()) {
      await this.userService.initialize();

      // Check if user has been requested to reset password.
      if (this.userService.currentUser?.recoveryRequested == true) {
        return this.router.parseUrl('/management/me#fpwchange');
      }

      return true;
    }
    else {
      return true;
    } 
  }
  
}
